<template>
  <Page title="Daftar Retribusi">
    <template v-slot:toolbar>
      <v-btn small color="primary" @click="ImportRetda" :disabled="loading">
        Import Retda
      </v-btn>
    </template>
    <Grid
      :datagrid.sync="users"
      dbref="AST.Retribusi"
      style="height:calc(100vh - 120px)"
      class="dense"
      :doRebind="gridRebind"
      :columns="[
        {
          name: 'Retribusi',
          value: 'KategoriName',
          width: '250px',
          editable: {
            com: 'Input',
          },
        },
        {
          name: 'Harga',
          value: 'Harga',
          width: '120px',
          editable: {
            com: 'Input',
            type: 'number',
          },
        },
      ]"
    >
      <template v-slot:row-Harga="{ row }">
        <div style="text-align:right">Rp. {{ row.Harga | format }}</div>
      </template>
    </Grid>
  </Page>
</template>
<script>
export default {
  components: {},
  data: () => ({
    loading: false,
    gridRebind: 1,
    roleAccess: false,
    showRolesPage: false,
    showAreaAccess: false,
    roleAccessData: [],
    rolesData: [],
    areaAccessData: [],
    roleId: null,
    userId: null,
    users: null,
    forms: {},
  }),
  async mounted() {},
  watch: {
    showRolesPage(val) {
      if (!val) {
        this.gridRebind++
      }
    },
  },
  methods: {
    ShowRoleAccess(roleId) {
      this.roleAccess = true
      this.roleId = roleId
    },
    ShowAreaAccess(userId) {
      this.showAreaAccess = true
      this.userId = userId
    },
    async ImportRetda() {
      this.loading = true
      setTimeout(async () => {
        await this.$api.call('AST_ResetRetribusi')
        this.loading = false
        this.gridRebind++
      }, 5000)
    },
  },
}
</script>
<style lang="scss">
#modal-role-access {
  .ui-table {
    height: 500px !important;
  }
}
</style>
